import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d4f1b50&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=0d4f1b50&prod&scoped=true&lang=scss&external"
import style1 from "@/components/ui/configuratorElements/style.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f1b50",
  null
  
)

export default component.exports